const LOCK_CLASS = "--scroll-locked"

let lockCount = 0
let lockedScrollY = 0

export function lockScroll(): void {
  lockCount += 1
  if (lockCount === 1) {
    lockedScrollY = window.scrollY
    document.body.style.top = `-${lockedScrollY}px`
    document.documentElement.classList.add(LOCK_CLASS)
  }
}

export function unlockScroll(): void {
  if (lockCount === 0) return

  lockCount -= 1
  if (lockCount === 0) {
    document.documentElement.classList.remove(LOCK_CLASS)
    document.body.style.top = ""
    window.scrollTo(0, lockedScrollY)
  }
}
